export const MENU_HEIGHT = 80;
export const MOBILE_MENU_HEIGHT = 44;
export const TOP_BANNER_HEIGHT = 70;
export const TOP_BANNER_HEIGHT_MOBILE = 84;
